(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-observer.js') >= 0) return;  svs.modules.push('/components/lb-utils/intersection-observer/assets/javascripts/react-intersection-observer.js');
"use strict";


const _React = React,
  useRef = _React.useRef,
  useEffect = _React.useEffect,
  useContext = _React.useContext;
const ReactIntersectionContext = svs.components.lbUtils.intersectionObserver.ReactIntersectionContext;
const ReactIntersectionObserver = _ref => {
  let onIntersection = _ref.onIntersection,
    children = _ref.children,
    _ref$isObserving = _ref.isObserving,
    isObserving = _ref$isObserving === void 0 ? true : _ref$isObserving,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options;
  const _useContext = useContext(ReactIntersectionContext),
    observeElement = _useContext.observeElement,
    unobserveElement = _useContext.unobserveElement,
    disconnectElement = _useContext.disconnectElement,
    connectElement = _useContext.connectElement,
    changeElementCallback = _useContext.changeElementCallback;
  const intersectionEl = useRef();
  useEffect(() => {
    const _intersectionEl = intersectionEl.current;
    connectElement(_intersectionEl, null, options);
    return () => {
      disconnectElement(_intersectionEl);
    };
  }, [connectElement, disconnectElement, options]);
  useEffect(() => {
    const _intersectionEl = intersectionEl.current;
    changeElementCallback(_intersectionEl, onIntersection);
  }, [onIntersection, changeElementCallback]);
  useEffect(() => {
    const _intersectionEl = intersectionEl.current;
    const _isObserving = isObserving;
    if (_isObserving) {
      observeElement(_intersectionEl);
    }
    return () => {
      if (_isObserving) {
        unobserveElement(_intersectionEl);
      }
    };
  }, [isObserving, observeElement, unobserveElement]);
  return React.createElement("div", {
    ref: intersectionEl
  }, children);
};
setGlobal('svs.components.lbUtils.intersectionObserver.ReactIntersectionObserver', ReactIntersectionObserver);

 })(window);